import { CreateVehicleMutationVariables } from "../../../generatedQueries";
import {
  Event,
  ConstructorArgs as EventConstructorArgs,
} from "../../core/Event";
import { EventCategories } from "../../event-categories";
import { EventSubCategories } from "../../event-sub-categories";

export type Data = {
  mutationVariables: CreateVehicleMutationVariables;
};

export type ConstructorArgs = Data & Partial<EventConstructorArgs>;

class CreateVehicleRequest extends Event<Data> {
  public constructor(args: ConstructorArgs) {
    const { mutationVariables, ...baseArgs } = args;

    super({
      ...baseArgs,
      category: EventCategories.UI,
      subCategory: EventSubCategories.VEHICLES,
      type: `CREATE_VEHICLE.REQUEST`,
      data: {
        mutationVariables,
      },
    });
  }
}

export { CreateVehicleRequest };
